module.exports = __webpack_public_path__ + "img/xr2_detail.348115dc.jpg";